import { ApolloLink } from '@apollo/client'
import * as Sentry from '@sentry/core'

export default function createSentryLink() {
  return new ApolloLink((operation, forward) => {
    const traceData = Sentry.getTraceData()
    if (traceData.baggage && traceData['sentry-trace']) {
      operation.setContext(({ headers = {} }) => ({
        headers: {
          ...headers,
          'sentry-trace': traceData['sentry-trace'],
          baggage: traceData.baggage,
        },
      }))
    }
    return forward(operation)
  })
}
